// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"OJ-z","carouselContainer":"PJ-z"};